<template>
  <div>
    <VIdleModule
      style="display: none"
      :duration="idleLimit"
      @idle="onIdle"
      @active="onActive"
    />
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import VIdleModule from '../VIdleModule/VIdleModule.vue'
export default defineComponent({
  name: 'IdleWatcher',
  components: {
    VIdleModule
  },
  setup (_, { emit }) {
    const isIdle = ref(false)
    const idleLimit = 7200

    const { getCurrentInstance } = require('@vue/composition-api')
    const store = getCurrentInstance().proxy.$store

    const setLastLogin = value => store.dispatch('UserStore/setLastLogin', value)

    const lastLogin = computed(() => {
      return store.state.UserStore?.lastLogin || ''
    })

    const onIdle = () => {
      isIdle.value = true
      console.log('Usuario inactivo')
      openSessionExtension()
    }

    const onActive = () => {
      isIdle.value = false
    }

    onMounted(() => {
      if (!lastLogin.value) {
        setLastLogin(new Date().toISOString())
      }
    })
    const openSessionExtension = () => {
      emit('openExtensionModal')
    }

    return {
      openSessionExtension,
      isIdle,
      onIdle,
      onActive,
      idleLimit
    }
  }
})
</script>
